import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/videos-requests/searchbar";
import VideosRequestTable from "../../../containers/admin/videos-requests/table";
import { getAllRequestsRequest } from "../../../modules/admin-modules/video-requests/Actions";
import UserQRCode from "../../../containers/admin/students/models/user-qr-code";
import StudentReport from "../../../containers/admin/students/models/student-report";

const VideosMoreViewRequests = () => {
  const dispatch = useDispatch();
  const studentReportModel = useSelector((state) => state.model.isOpen18);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllRequestsRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <VideosRequestTable setSelectedData={setSelectedData} searchTerm={searchTerm} />
      <UserQRCode data={selectedData?.student} setSelectedData={setSelectedData} />
      {studentReportModel && (
        <StudentReport student_id={selectedData?.id} selectedData={selectedData} />
      )}
    </Layout>
  );
};

export default VideosMoreViewRequests;
